import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'clearing-operations',
        label: 'Operations',
        to: '/clearing/operations',
      }),
    }) satisfies AggregateBreadcrumb,
});
